import { useOrderAheadMapper } from "@/store/modules/orderAhead/mapper";
import { getMaskedEmail } from "./payments";

export const prependUsdSign = (value: number): string => {
  const NUMBERS_AFTER_COMMA = 2;
  return value >= 0 ? "$" + (+value).toFixed(NUMBERS_AFTER_COMMA) : "--";
};

export const last4digits = (digits: string): string => {
  return digits?.length > 0 ? `**** ${digits.slice(digits.length - 4, digits.length)}` : "";
};

export const maskedCredential = (amenity: string): string => {
  const isEmail = amenity?.includes("@");
  if (isEmail) {
    return getMaskedEmail(amenity);
  }
  return last4digits(amenity);
};

export const parsedDate = (val: string, timezone: string): string => {
  const { mapToFormattedDate, mapToTime } = useOrderAheadMapper();
  return `${mapToFormattedDate(val, timezone)} - ${mapToTime(val, timezone)}`;
};

export const addition = (value: string | number): string => {
  return value !== "--" ? `+ ${value}` : value;
};
